import * as React from 'react';
import './styles.sass';

export interface ISessionDashboardButtonProps {
  url: string;
  target?: string;
}

export const SessionDashboardButton: React.StatelessComponent<ISessionDashboardButtonProps>
  = ({url, target}: ISessionDashboardButtonProps) => (
    <a
      href={url}
      className={'session-dashboard-button'}
      target={target || '_blank'}
    >
      <i className={'fa fa-angle-left session-dashboard-button__icon'} />
      <span className={'session-dashboard-button__label'}>Dashboard</span>
    </a>
  );
